import { Appointment, EnvironmentType } from '../types';

export function requiresPaymentAtBooking(categoryId: number, env: EnvironmentType) {
  if (env === 'production' || env === 'uat') {
    // On production, the id for coaching (requires payment up front) is 3
    return categoryId === 3;
  }
  // On staging, the coaching category is 2
  return categoryId === 2;
}

export function isGYNAppointment(categoryId: number, env: EnvironmentType) {
  if (env === 'production' || env === 'uat') {
    // On production, the id for GYN is 2
    return categoryId === 2;
  }
  // On staging, the GYN category is 3
  return categoryId === 3;
}

export function isMembersOnly(_categoryId: number, _env: EnvironmentType) {
  return false; // currently no categories restricted by membership!
}

export function isFertility(categoryId: number) {
  // the id for both staging & prod is the same for Fertility category
  return categoryId === 1;
}

const AppointmentTypesProduction = {
  AMH: '57',
  CYCLE_VISIT: '9',
  EMBRYO_TRANSFER: '33',
  FERTILITY_ASSESSMENT: ['3', '58', '59', '93', '112', '312', '313', '157', '319', '320', '351'],
  FOLLOW_UP: '21',
  INITIAL_CYCLE_VISIT: '35',
  IUI_PROCEDURE: ['34', '77'],
  PREGNANCY: '75',
  PROGESTERONE: '76',
  RETRIEVAL: '15',
  VIRTUAL_CONSULTATION: ['143', '144'],
  NEW_OB_VISIT: '189',
  PULSE_ULTRASOUND_BLOODWORK: '351'
};

const AppointmentTypesStaging = {
  AMH: '20',
  CYCLE_VISIT: '7',
  EMBRYO_TRANSFER: '27',
  FERTILITY_ASSESSMENT: ['18', '23', '41', '112', '312', '313', '157', '319', '320', '351'],
  FOLLOW_UP: '5',
  INITIAL_CYCLE_VISIT: '4',
  IUI_PROCEDURE: ['40'],
  PREGNANCY: '28',
  PROGESTERONE: '26',
  RETRIEVAL: '15',
  VIRTUAL_CONSULTATION: '48',
  NEW_OB_VISIT: '189',
  PULSE_ULTRASOUND_BLOODWORK: '351'
};

export function appointmentTypes(env: EnvironmentType) {
  if (env === 'production' || env === 'uat') {
    return AppointmentTypesProduction;
  }
  return AppointmentTypesStaging;
}

export function isAssessment(appt: Appointment, env: EnvironmentType) {
  const fertilityAssessmentIds: string[] = appointmentTypes(env).FERTILITY_ASSESSMENT;
  return fertilityAssessmentIds.includes(appt.appointmentType.id);
}

export function isVirtualConsultation(appt: Appointment, env: EnvironmentType) {
  const virtualConsultationIds: string | string[] = appointmentTypes(env).VIRTUAL_CONSULTATION;
  return virtualConsultationIds.includes(appt.appointmentType.id);
}

export function isIUIProcedure(appt: Appointment, env: EnvironmentType) {
  const iuiProcedureIds: string[] = appointmentTypes(env).IUI_PROCEDURE;
  return iuiProcedureIds.includes(appt.appointmentType.id);
}

export function isInitialCycleVisit(appt: Appointment, env: EnvironmentType) {
  const initialCycleVisitId: string = appointmentTypes(env).INITIAL_CYCLE_VISIT;
  return appt.appointmentType.id === initialCycleVisitId;
}

export function isCycleVisit(appt: Appointment, env: EnvironmentType) {
  const cycleVisitId: string = appointmentTypes(env).CYCLE_VISIT;
  return appt.appointmentType.id === cycleVisitId;
}

export function isRetrieval(appt: Appointment, env: EnvironmentType) {
  const retrievalId: string = appointmentTypes(env).RETRIEVAL;
  return appt.appointmentType.id === retrievalId;
}

export function isFollowUp(appt: Appointment, env: EnvironmentType) {
  const followUpId: string = appointmentTypes(env).FOLLOW_UP;
  return appt.appointmentType.id === followUpId;
}

export function isPregnancyTest(appt: Appointment, env: EnvironmentType) {
  const pregnancyTestId: string = appointmentTypes(env).PREGNANCY;
  return appt.appointmentType.id === pregnancyTestId;
}

export function isEmbryoTransfer(appt: Appointment, env: EnvironmentType) {
  const embryoTransfer: string = appointmentTypes(env).EMBRYO_TRANSFER;
  return appt.appointmentType.id === embryoTransfer;
}

export function isPulseUltrasoundBloodwork(appt: Appointment, env: EnvironmentType) {
  const pulseUltrasoundBloodwork: string = appointmentTypes(env).PULSE_ULTRASOUND_BLOODWORK;
  return appt.appointmentType.id === pulseUltrasoundBloodwork;
}

export function isAMH(appt: Appointment, env: EnvironmentType) {
  return appt.appointmentType.id === appointmentTypes(env).AMH;
}

export function cycleVisitId(env: EnvironmentType) {
  return appointmentTypes(env).CYCLE_VISIT;
}

export function initialCycleVisitId(env: EnvironmentType) {
  return appointmentTypes(env).INITIAL_CYCLE_VISIT;
}
